<template>
  <el-select v-bind="$attrs" filterable clearable remote :remote-method="remoteMethod" v-model="curSelect" popper-class="el-select-thick-scrollbar">
    <el-option
      v-for="item in optionsList"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
import $ from 'jquery';
import {ajax} from "@/api/jqajax";

export default {
  components: {},
  computed: {},
  model: {
    prop: 'value'
  },
  props: {
    value: {type: [String, Number], default: ''},
    remote: {type: Boolean, default: true},
    limit: {type: Number, default: 30000000}
  },
  data() {
    return {
      optionsList: [],
      curSelect: this.value
    };
  },
  created() {
    this.load()
  },
  mounted() {
    this.$emit('other',this.getOther())

  },

  watch: {
    value(newval) {
      this.curSelect = newval;
    },
    curSelect(newval) {
      this.$emit('input', newval)
      this.$emit('other',this.getOther())

    }
  },
  methods: {
    load(keyword = '') {
      ajax('get', {page: 1, per_page: this.limit, keyword}, 'admin/member', (res) => {
        if (res.error_code == '0') {
          this.optionsList = res.data.data;
        }
      })
    },
    remoteMethod(query) {
      this.load(query)
    },
    getOther(){
      return this.optionsList.find(item=>item.id==this.curSelect)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/projectComponents/user.vue